import visa from '../../../assets/paymentsImg/visa.png'
import mastercard from '../../../assets/paymentsImg/masterCard.png'
import amex from '../../../assets/paymentsImg/amex.png'
import elo from '../../../assets/paymentsImg/elo.png'
import hiper from '../../../assets/paymentsImg/hiperCard.png'
import pix from '../../../assets/paymentsImg/pix.png'
import boleto from '../../../assets/paymentsImg/boleto.png'

const PAYMENT_METHODS = [
  { name: 'VISA', image: visa },
  { name: 'Mastercard', image: mastercard },
  { name: 'Amex', image: amex },
  { name: 'Elo', image: elo },
  { name: 'Hiper', image: hiper },
  { name: 'Pix', image: pix },
  { name: 'Boleto', image: boleto }
]

export function PaymentMethods() {
  return (
    <div className="mt-4 w-full">
      <div className="flex flex-nowrap items-center justify-center gap-1.5 sm:justify-start sm:gap-3">
        {PAYMENT_METHODS.map((method) => (
          <div key={method.name} className="flex shrink-0 items-center justify-center">
            <img src={method.image} alt={method.name} className="h-5 w-8 rounded-md object-contain sm:h-8 sm:w-13" />
          </div>
        ))}
      </div>
    </div>
  )
}
